import {GridToolbarContainer} from '@mui/x-data-grid-pro';
import {
  Button,
  ButtonGroup,
  Checkbox,
  FormControlLabel,
  Tooltip,
  Typography,
} from '@mui/material';
import {Create, Delete, Update, Sync} from '@mui/icons-material';
import React, {PropsWithChildren} from 'react';
import {SaltusAny} from '../../utils/SaltusAny';

const ToolbarButton = Button;

function dummyFunc() {
  // eslint-disable-next-line no-console
  console.debug('Click performed');
}

interface EditorToolBarProps {
  syncFunc: boolean | ((selectedId: string | null) => void);
  createFunc: boolean | (() => void);
  createFuncLoading: boolean;
  updateFunc: boolean | ((selectedId: string | null) => void);
  deleteFunc: SaltusAny; // tricky one
  selectedId?: string;
  setSelectedId: (selectedId: string | null) => void;
  rowsFiltered?: boolean;
  filterRowsFunc?: (args: SaltusAny) => SaltusAny;
  rowsFilteredLabel?: string;
  rowsFilteredTooltip?: string;
}

const EditorToolBar: React.FC<PropsWithChildren<EditorToolBarProps>> = (props) => {
  const {
    selectedId = null,
    setSelectedId,
    rowsFiltered = undefined,
    filterRowsFunc = null,
    rowsFilteredLabel = null,
    rowsFilteredTooltip = null,
    createFuncLoading,
    children,
  } = props;
  let {createFunc, updateFunc, deleteFunc, syncFunc} = props;

  const deleteAndUnselect = async () => {
    if (selectedId !== null && deleteFunc) {
      await deleteFunc(selectedId);
      setSelectedId(null);
    }
  };

  const updateWithId = () => {
    if (selectedId !== null && typeof updateFunc === 'function') {
      updateFunc(selectedId);
    }
  };

  const syncWithId = () => {
    if (typeof syncFunc === 'function') {
      syncFunc(selectedId);
    }
  };

  if (createFunc === true) {
    createFunc = dummyFunc;
  }

  if (updateFunc === true) {
    updateFunc = dummyFunc;
  }

  if (syncFunc === true) {
    syncFunc = dummyFunc;
  }

  if (deleteFunc === true) {
    deleteFunc = new Promise(() => {});
  }

  return (
    <GridToolbarContainer>
      <div style={{flexGrow: 1}} />
      {filterRowsFunc && (
        <Tooltip title={rowsFilteredTooltip}>
          <FormControlLabel
            control={
              <Checkbox
                color="primary"
                checked={rowsFiltered}
                onChange={filterRowsFunc}
                name="rowsFiltered"
              />
            }
            label={
              <Typography variant="caption" color="primary">
                {rowsFilteredLabel}
              </Typography>
            }
          />
        </Tooltip>
      )}
      <ButtonGroup color="primary" aria-label="Table action buttons" size="small">
        {children}
        {syncFunc && (
          <ToolbarButton onClick={syncWithId} startIcon={<Sync />}>
            Sync item
          </ToolbarButton>
        )}
        {createFunc && (
          <ToolbarButton
            data-test="Grid Create"
            disabled={createFuncLoading}
            onClick={createFunc}
            startIcon={<Create />}
          >
            {createFuncLoading ? 'Creating...' : 'Create'}
          </ToolbarButton>
        )}
        {updateFunc && (
          <ToolbarButton onClick={updateWithId} startIcon={<Update />}>
            Update
          </ToolbarButton>
        )}
        {deleteFunc && (
          <ToolbarButton onClick={deleteAndUnselect} startIcon={<Delete />}>
            Delete
          </ToolbarButton>
        )}
      </ButtonGroup>
    </GridToolbarContainer>
  );
};

export default EditorToolBar;
